import { slugify } from "../../../../utils/slugifyString";

export const getRegion = (searchState) => {
  const data = [
    {
      label: "ALSACE CHAMPAGNE-ARDENNE LORRAINE",
      longitude: 5.6194,
      latitude: 48.6892,
    },
    {
      label: "AQUITAINE LIMOUSIN POITOU-CHARENTES",
      longitude: 0.1978,
      latitude: 45.1922,
    },
    { label: "AUVERGNE RHÔNE-ALPES", longitude: 4.5381, latitude: 45.5158 },
    { label: "BOURGOGNE FRANCHE-COMTÉ", longitude: 4.8092, latitude: 47.2353 },
    { label: "BRETAGNE", longitude: -2.8386, latitude: 48.1797 },
    { label: "CENTRE-VAL DE LOIRE", longitude: 1.6853, latitude: 47.4806 },
    { label: "CORSE", longitude: 9.1053, latitude: 42.1497 },
    { label: "ÎLE-DE-FRANCE", longitude: 2.5047, latitude: 48.7092 },
    {
      label: "OCCITANIE",
      longitude: 2.1372,
      latitude: 43.7022,
    },
    {
      label: "NORD-PAS-DE-CALAIS PICARDIE",
      longitude: 2.7753,
      latitude: 49.9661,
    },
    { label: "NORMANDIE", longitude: 0.1067, latitude: 49.1211 },
    { label: "PAYS DE LA LOIRE", longitude: -0.8239, latitude: 47.4747 },
    {
      label: "PROVENCE-ALPES-CÔTE D'AZUR",
      longitude: 6.0533,
      latitude: 43.955,
    },
  ];

  let results = [];
  if (searchState?.length > 1) {
    results = data
      .filter((region) => {
        if (slugify(region.label).includes(slugify(searchState))) {
          return region;
        }
      })
      .map((region) => {
        return {
          geometry: {
            coordinates: [region.longitude, region.latitude],
          },
          properties: {
            id: slugify(region.label),
            label: region.label,
            type: "region",
          },
        };
      });

    if (results?.length > 2) {
      results = results.slice(1);
    }
  }

  return results;
};
